// Initialize Google Sign-In button only (no One Tap prompt)

let googleSubmitInProgress = false;

function submitGoogleToken(token) {
  if (!token || googleSubmitInProgress) {
    return;
  }
  googleSubmitInProgress = true;

  const csrfToken = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content');
  const form = document.createElement('form');
  form.method = 'POST';
  form.action = '/auth/sign_in';
  form.style.display = 'none';

  const tokenInput = document.createElement('input');
  tokenInput.type = 'hidden';
  tokenInput.name = 'google_token';
  tokenInput.value = token;
  form.appendChild(tokenInput);

  if (csrfToken) {
    const csrfInput = document.createElement('input');
    csrfInput.type = 'hidden';
    csrfInput.name = 'authenticity_token';
    csrfInput.value = csrfToken;
    form.appendChild(csrfInput);
  }

  document.body.appendChild(form);
  form.submit();
}

// Wait for Google library to load
function initializeGoogleSignIn() {
  if (window.location.pathname !== '/auth/sign_in') {
    return;
  }

  const clientId = window.GOOGLE_CLIENT_ID;
  const buttonContainer = document.getElementById('google-signin-button');
  if (!clientId || !buttonContainer) {
    return;
  }

  if (typeof google !== 'undefined' && google.accounts && google.accounts.id) {
    google.accounts.id.initialize({
      client_id: clientId,
      callback: handleGoogleLogin
    });

    const isDarkMode = document.documentElement.classList.contains('dark-mode') ||
      document.body.classList.contains('dark-mode');

    google.accounts.id.renderButton(buttonContainer, {
      type: 'standard',
      theme: isDarkMode ? 'filled_black' : 'outline',
      size: 'large',
      width: 300,
      text: 'signin_with',
      shape: 'rectangular',
      logo_alignment: 'left'
    });

    google.accounts.id.disableAutoSelect();
  } else {
    setTimeout(initializeGoogleSignIn, 100);
  }
}

function handleGoogleLogin(response) {
  const token = response?.credential;
  if (!token) {
    return;
  }

  const googleTokenInput = document.getElementById('google-token');
  if (googleTokenInput) {
    googleTokenInput.value = token;
  }

  submitGoogleToken(token);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeGoogleSignIn);
} else {
  initializeGoogleSignIn();
}

window.handleGoogleLogin = handleGoogleLogin;
